import { GridItemProps, GridProps } from "./Layout.types";
import { GridItemWrapper, GridWrapper } from "./Layout.styles";
import React, { useEffect, useState } from "react";

export const LegacyGrid: React.FC<
  { children: React.ReactNode } & GridProps
> = ({ children, ...props }) => {
  const [width, setWidth] = useState(Math.min(window.innerWidth, 448));

  useEffect(() => {
    const updateWidth = () => {
      setWidth(Math.min(window.innerWidth, 448));
    };

    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  return (
    <GridWrapper width={width} {...props}>
      {children}
    </GridWrapper>
  );
};

export const LegacyGridItem: React.FC<
  { children: React.ReactNode } & GridItemProps & GridProps
> = ({ children, w, ...props }) => {
  const calculateItemWidth = () => {
    const maxWidth = Math.min(window.innerWidth, 448);
    const baseUnit = (maxWidth - 150) / 12;
    return w === 1 ? baseUnit : w * baseUnit + 10 * (w - 1);
  };

  const [itemWidth, setItemWidth] = useState(calculateItemWidth);

  useEffect(() => {
    const updateItemWidth = () => setItemWidth(calculateItemWidth());
    window.addEventListener("resize", updateItemWidth);
    return () => window.removeEventListener("resize", updateItemWidth);
  }, [w]);

  return (
    <GridItemWrapper width={itemWidth} {...props}>
      {children}
    </GridItemWrapper>
  );
};
